module.exports = __webpack_public_path__ + "static/media/chat.a2564a9f.svg";